import React from "react";
import consult from "../../images/Assets/consultImg.png";

export default function Consult() {
  return (
    <div className="consultBg md:px-6 xl:px-10 px-28 pt-20 pb-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex md:flex-col flex-row items-start justify-center xl:gap-10 gap-32">
          <div className="w-full flex items-center justify-center">
            <img src={consult} alt="consult" />
          </div>

          <div className="w-full">
            <div className="md:text-[28px] text-[40px] text-[#0E062A] font-gilroySemibold leading-[52px] text-start mt-2">
              Consulting for AI
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-5">
              At Komodo AI, we partner with startups to build cutting-edge <br className="2xl:hidden block" />{" "}
              AI solutions, empowering businesses with the technology of the{" "}
              <br className="2xl:hidden block" /> future, today.
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-2">
              <span className="font-gilroyBold">Our promise?</span> An AI solution that's not only functional
              but <br className="2xl:hidden block" /> perfectly aligned with your business goals and the needs
              of <br className="2xl:hidden block" /> your market.
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-2">
              Your startup has the ideas and the vision; we bring the AI <br className="2xl:hidden block" />{" "}
              expertise. Together, we can build something extraordinary. We{" "}
              <br className="2xl:hidden block" /> don't just develop AI software; we work closely with you to{" "}
              <br className="2xl:hidden block" /> create a solution tailored specifically to your needs.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
